/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Quantity_PositiveInputs */

const vi_validation_quantity_positive = /** @type {(inputs: Validation_Quantity_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng phải lớn hơn 0`)
};

/**

* @param {Validation_Quantity_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_quantity_positive = /** @type {((inputs?: Validation_Quantity_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Quantity_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_quantity_positive(inputs)
});